import { render, staticRenderFns } from "./DashboardOtherAdhesions.vue?vue&type=template&id=a3c99a82&"
import script from "./DashboardOtherAdhesions.vue?vue&type=script&lang=js&"
export * from "./DashboardOtherAdhesions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOtherAdhesions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports